import type { Coordinates, RouteInfo } from '../types'

export interface RouteProvider {
  readonly name: string
  getRoute(origin: Coordinates, destination: Coordinates): Promise<RouteInfo>
}

export class RouteProviderError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'RouteProviderError'
  }
}
